export default class SearchOptions {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.searchInput = this.DOM.el.querySelector("#search-options");
        this.DOM.optionItems = Array.from(document.querySelectorAll(".option-item"));
        this.DOM.optionGroups = Array.from(document.querySelectorAll(".option-group"));
        this.DOM.highlightsContainer = document.querySelector("#highlights-container");
        this.DOM.noResultsMessage = document.querySelector("#no-results-message");

        this.initEvents();
    }

    initEvents() {
        this.DOM.searchInput.addEventListener("input", () => this.filterOptions());
    }

    filterOptions() {
        const searchTerm = this.DOM.searchInput.value.toLowerCase();
        let hasResults = false;

        this.DOM.optionItems.forEach((item) => {
            const text = item.textContent.toLowerCase();
            const parentGroup = item.closest(".option-group");

            if (text.includes(searchTerm)) {
                item.classList.remove("d-none");
                hasResults = true;
            } else {
                item.classList.add("d-none");
            }

            // Controleer of de groep nog items heeft, anders verberg deze
            if (parentGroup) {
                const visibleItems = parentGroup.querySelectorAll(".option-item:not(.d-none)");
                if (visibleItems.length > 0) {
                    parentGroup.classList.remove("d-none");
                } else {
                    parentGroup.classList.add("d-none");
                }
            }
        });

        // Verberg de highlights-container wanneer er geen zichtbare highlights meer zijn
        const visibleHighlights = this.DOM.highlightsContainer.querySelectorAll(".option-item:not(.d-none)");
        if (visibleHighlights.length > 0) {
            this.DOM.highlightsContainer.classList.remove("d-none");
            hasResults = true;
        } else {
            this.DOM.highlightsContainer.classList.add("d-none");
        }

        // Toon "Geen resultaten" als er niks gevonden is
        if (!hasResults) {
            this.DOM.noResultsMessage.classList.remove("d-none");
        } else {
            this.DOM.noResultsMessage.classList.add("d-none");
        }
    }
}

const searchOptionsNode = document.querySelector("#vehicle-options");
if (searchOptionsNode) {
    new SearchOptions(searchOptionsNode);
}
